export const MOBILE_QUESTION_MARK =
  'https://static.pw.live/production-curiousjr-fundoo/static/images/QuestionMarkAuth.svg'
export const FACULTY_BG =
  'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/d9e7a426-0226-4daf-8577-022eca759cf5.webp'
export const PLAY_ICON =
  'https://static.pw.live/production-curiousjr-fundoo/static/images/video-play-white.svg'
export const FLAIR_IMG = 'https://static.pw.live/production-curiousjr-fundoo/static/images/flair.svg'
export const LEFT_QUOTE = 'https://static.pw.live/production-curiousjr-fundoo/static/images/left-quotes.svg'
export const RIGHT_QUOTE = 'https://static.pw.live/production-curiousjr-fundoo/static/images/right-quotes.svg'
export const HEADING_TOP_DECORATOR =
  'https://static.pw.live/production-curiousjr-fundoo/static/images/heading-text-top.svg'
export const GLOBE_ICON =
  'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/c60da125-9760-4f3b-ab9d-08fdfe7d9a5e.webp'
export const BULB_ICON =
  'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/b170fbf8-01d7-4f17-b6f5-6d3b16b37f80.webp'
export const RULER_ICON =
  'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/e6a44b4c-f64e-4406-87e5-ac4525b54eab.webp'
export const BEAKER_ICON =
  'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/76b471ff-097e-4b5d-a7fa-67479baf76be.webp'
export const ROCKET_ICON =
  'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/9a3cd6b7-a559-4395-bbd7-59baaf2e7546.webp'
export const UNDERLINE_IMAGE =
  'https://static.pw.live/production-curiousjr-fundoo/static/images/Revamp/UnderLine.svg'
export const FALLBACK_IMAGE =
  'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/b3fb6572-7616-4da1-ae57-6e2025a6bc67.webp'
export const VIDEO_BANNER =
  'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4'
export const MWEB_VIDEO_BANNER =
  'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4'
